<div class="order-paid-date-view item flex align-items-center">
  <div class="item__icon">
    <mat-icon color="accent" class="custom-icons">calendar_today</mat-icon>
  </div>
  <div class="item__description ms-3">
    <strong>Paid Date:</strong>
    <span class="ms-3">{{ paidDate }}</span>
  </div>
</div>